import React, { PropTypes } from 'react';
import { Link } from 'react-router';
import classNames from 'classnames';

import AverageRating from 'AppComponents/AverageRating';
import Distance from 'AppComponents/Distance';

import './styles.scss';

const Place = (props, context) => {
  const { place, onMouseEnter, onMouseLeave } = props;
  return (
    <Link
      className={classNames('list-group-item', 'list-group-item-action', 'place', 'place-icon', place.category, {
        'no-address': !place.address,
      })}
      styleName='place'
      to={`/${place.category}/${place.pk}/`}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >

      <div styleName='content'>

        <h4>{ place.name }</h4>

        { place.distance_from_charger ?
          <p className='text-muted'>
            <Distance value={place.distance_from_charger} imperial={context.imperial || false} />
            &nbsp;from charger
          </p>
        : null }

        { place.factual_data.category_labels ?
          <p className='text-muted'>{
            place.factual_data.category_labels[0][place.factual_data.category_labels[0].length - 1]
          }</p>
        : null }

        { place.average_rating ?
          <AverageRating rating={place.average_rating} styleName='rating' />
        : null }

        { place.average_walkability_rating ?
          <AverageRating rating={place.average_walkability_rating} styleName='rating' type='walk' />
        : null }

      </div>

    </Link>
  );
};

Place.propTypes = {
  onMouseEnter: PropTypes.func,
  onMouseLeave: PropTypes.func,
  place: PropTypes.shape({
    pk: PropTypes.string,
    name: PropTypes.string,
    address: PropTypes.object,
    category: PropTypes.string,
    distance_from_charger: PropTypes.number,
    factual_data: PropTypes.object,
    average_rating: PropTypes.number,
    average_walkability_rating: PropTypes.number,
  }).isRequired,
};

Place.defaultProps = {
  onMouseEnter: null,
  onMouseLeave: null,
};

Place.contextTypes = {
  imperial: PropTypes.bool,
};

export default Place;



// WEBPACK FOOTER //
// ./app/scripts/views/App/views/Charger/components/Places/Place/index.jsx